import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import {
  TableRow,
  TableCell,
  Typography,
  IconButton,
  Button,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';
import Styles from '../Styles/ListCustodiansStyles';
import CustodianSearchResult from '../../../Models/custodian/custodianSearchResult';
import { green, red } from '@mui/material/colors';

export default function CustodianTableRow({
  custodianRow,
  handleRowToggle,
  isRowExpanded,
  showSelectBtn,
  selectBtnClicked,
}: {
  custodianRow: CustodianSearchResult;
  handleRowToggle: (id: number) => void;
  isRowExpanded: (id: number) => boolean;
  showSelectBtn?: boolean;
  selectBtnClicked?: (item: any) => void;
}) {
  return (
    <TableRow
      onClick={() => handleRowToggle(custodianRow.id)}
      sx={Styles.tableRowStyles}
    >
      <TableCell>
        <Typography>
          <Link
            to={`/entity/details/${custodianRow.id}`}
            target="_blank"
            style={Styles.viewCustodianLinkStyles}
          >
            {custodianRow.name}
          </Link>
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={Styles.custodianTableCellStyles}>
          {custodianRow.address}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={Styles.custodianTableCellStyles}>
          {custodianRow.city}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={Styles.custodianTableCellStyles}>
          {custodianRow.stateName}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={Styles.custodianTableCellStyles}>
          {custodianRow.type}
        </Typography>
      </TableCell>
      <TableCell>
        <Box
          sx={{
            display: 'inline-block',
            padding: '2px 12px',
            borderRadius: '4px',
            backgroundColor: custodianRow.disabled ? red[100] : green[100],
            color: custodianRow.disabled ? red[700] : green[700],
            fontWeight: '500',
            fontSize: '12px',
            textTransform: 'capitalize',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}
        >
          <Typography>
            {custodianRow.disabled ? 'Inactive' : 'Active'}
          </Typography>
        </Box>
      </TableCell>
      {showSelectBtn ? (
        <TableCell>
          <Typography>
            <Button
              size="small"
              id="select"
              name="select"
              disabled={custodianRow.disabled}
              onClick={() => {
                if (selectBtnClicked) selectBtnClicked(custodianRow);
              }}
              sx={{
                backgroundColor: '#F97316',
                color: 'white',
                borderRadius: '8px',
                textTransform: 'none',
                padding: '6px 16px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease',

                '&:hover': {
                  backgroundColor: '#D25B10',
                  boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
                },
                '&:disabled': {
                  backgroundColor: '#F4B184',
                  color: '#999',
                  boxShadow: 'none',
                },
              }}
            >
              Select
            </Button>
          </Typography>
        </TableCell>
      ) : (
        ''
      )}
    </TableRow>
  );
}
